
import "/root/workspace/csida-www_g32F/src/components/MobileGuide/index.less?modules";
export default {"subText": `subText-PpZJAouJ`,"container": `container-B6o30TBH`,"text": `text-1JyOQ-u9`,"content": `content-9E_ZqiKM`,"qrcode": `qrcode-ti_Z95X0`}
